import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=b6dfb87e&"
import script from "./UpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6dfb87e')) {
      api.createRecord('b6dfb87e', component.options)
    } else {
      api.reload('b6dfb87e', component.options)
    }
    module.hot.accept("./UpdatePassword.vue?vue&type=template&id=b6dfb87e&", function () {
      api.rerender('b6dfb87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/vistas/UpdatePassword.vue"
export default component.exports